import React from "react";
import Hero from "@/components/Hero";
import CategoriesGrid from "@/components/CategoriesGrid";
import ProjectsGallery from "@/components/ProjectsGallery";
import Reviews from "@/components/Reviews";

export default function HomePage() {
  return (
    <main>
      <Hero />
      <CategoriesGrid />
      <ProjectsGallery />
      <Reviews />
    </main>
  );
}
